import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SapMaterialTypeService } from '../proxy/controlling/controllers/sap-material-type.service';

FieldBuilder.setNamespace('Controlling');

export const SAPMATERIALGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.SapMaterialGroup.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('description', 'Entity.SapMaterialGroup.Description')
    .maxLength(100)
    .build(),
  FieldBuilder.foreignKey(
    'sapMaterialTypeId',
    'Entity.SapMaterialType',
    SapMaterialTypeService
  )
    .required()
    .display('sapCode')
    .build(),
];

export const SAPMATERIALGROUP_CONFIG = {
  entityName: 'SapMaterialGroup',
  localizationKey: 'Controlling::Entity.SapMaterialGroup',
  fields: SAPMATERIALGROUP_FIELDS,
  permission: 'ControllingSap.SapMaterialGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
